import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { UserHasPlusDto } from "@/core/features/users-have-pluses/user-has-plus.dto";
import { CreateUserHasPlusDto } from "@/core/features/users-have-pluses/create-user-has-plus.dto";
import { UpdateUserHasPlusDto } from "@/core/features/users-have-pluses/update-user-has-plus.dto";

export class UsersHavePlusesResource extends ResourceBaseService<
  UserHasPlusDto,
  CreateUserHasPlusDto,
  UpdateUserHasPlusDto
> {
  protected EntityDto = UserHasPlusDto;
  protected CreateEntityDto = CreateUserHasPlusDto;
  protected UpdateEntityDto = UpdateUserHasPlusDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/users-have-pluses");
  }
}
